import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions, { UPLOAD_FREELANCERS, CREATE_FREELANCERS } from '../actions';

export const uploadFreelancersEpic = (action$, store, { api }) =>
    action$.ofType(UPLOAD_FREELANCERS).mergeMap(action =>
        Observable.from(api.uploadFreelancerCSV(action.payload))
            .map(response => actions.uploadFreelancersSuccess(response.data))
            .catch(error =>
                Observable.of(
                    actions.uploadFreelancersFailure(
                        error && error.response.data,
                    ),
                ),
            ),
    );

export const createFreelancersEpic = (action$, store, { api }) =>
    action$.ofType(CREATE_FREELANCERS).mergeMap(action =>
        Observable.from(api.createFreelancers(action.payload))
            .map(response => actions.createFreelancersSuccess(response.data))
            .catch(error =>
                Observable.of(
                    actions.createFreelancersFailure(
                        error && error.response.data,
                    ),
                ),
            ),
    );
